var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.height_limit ? "parent" : "parent-long" },
    [
      _c("comments", {
        attrs: { joborderid: _vm.comment_joborderid, show: _vm.show_comments },
        on: { cancel: _vm.cancel_comment, save: _vm.save_comment }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "inline-block" } },
        [
          _vm.searchbar == true
            ? _c(
                "div",
                { staticClass: "search-field", staticStyle: { float: "left" } },
                [
                  _c(
                    "button",
                    {
                      staticStyle: { height: "30px", width: "40px" },
                      on: {
                        click: function($event) {
                          return _vm.clear()
                        }
                      }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search_term,
                        expression: "search_term"
                      }
                    ],
                    domProps: { value: _vm.search_term },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.setRouter(true)
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.search_term = $event.target.value
                        },
                        function($event) {
                          return _vm.setRouter(false)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticStyle: { height: "30px", width: "40px" },
                      on: {
                        click: function($event) {
                          return _vm.setRouter(true)
                        }
                      }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "search" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("b", [_vm._v("Limit")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.limit,
                        expression: "limit"
                      }
                    ],
                    staticStyle: { width: "60px" },
                    domProps: { value: _vm.limit },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.setRouter(true)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.limit = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.usePages == true ? _c("b", [_vm._v("Page")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.usePages == true
                    ? _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.addPage(-1)
                            }
                          }
                        },
                        [_vm._v("<")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.usePages == true
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.page,
                            expression: "page"
                          }
                        ],
                        staticStyle: { width: "60px" },
                        domProps: { value: _vm.page },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setRouter(true)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.page = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.usePages == true
                    ? _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.addPage(1)
                            }
                          }
                        },
                        [_vm._v(">")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.use_size == true ? _c("b", [_vm._v("Size")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.use_size == true
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.heightScale,
                            expression: "heightScale"
                          }
                        ],
                        staticStyle: { width: "60px" },
                        domProps: { value: _vm.heightScale },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.heightScale = $event.target.value
                          }
                        }
                      })
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.filter_options != null && _vm.filter_options.length > 0
            ? _c("filtr", {
                staticStyle: { float: "left" },
                attrs: { id: _vm.id, filter_options: _vm.filter_options },
                on: { input: _vm.setData }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "scroll",
          style: _vm.navbar ? "margin-bottom:50px" : "margin-bottom:10px"
        },
        [
          _c("table", { key: _vm.update_key }, [
            _vm.column_names.length > 0
              ? _c("thead", [
                  _vm.collapseable == true
                    ? _c("tr", [
                        _c("th", { staticStyle: { width: "30px" } }, [
                          _vm.collapsed == false
                            ? _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.collapse()
                                    }
                                  }
                                },
                                [_vm._v("-")]
                              )
                            : _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.collapse()
                                    }
                                  }
                                },
                                [_vm._v("+")]
                              )
                        ]),
                        _vm._v(" "),
                        _vm.button_name != null &&
                        _vm.perms.includes(_vm.button_perm)
                          ? _c(
                              "th",
                              {
                                staticClass: "table-header",
                                attrs: { colspan: _vm.column_names.length }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.table_name) +
                                    " Table "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "copy-table",
                                    on: {
                                      click: function($event) {
                                        return _vm.copyTable()
                                      }
                                    }
                                  },
                                  [_vm._v("Copy Table")]
                                )
                              ]
                            )
                          : _c(
                              "th",
                              {
                                staticClass: "table-header",
                                attrs: { colspan: _vm.column_names.length - 1 }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.table_name) +
                                    " Table "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "copy-table",
                                    on: {
                                      click: function($event) {
                                        return _vm.copyTable()
                                      }
                                    }
                                  },
                                  [_vm._v("Copy Table")]
                                )
                              ]
                            )
                      ])
                    : _c("tr", [
                        _vm.button_name != null &&
                        _vm.perms.includes(_vm.button_perm)
                          ? _c(
                              "th",
                              {
                                staticClass: "table-header",
                                attrs: { colspan: _vm.column_names.length + 1 }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.table_name) +
                                    " Table "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "copy-table",
                                    on: {
                                      click: function($event) {
                                        return _vm.copyTable()
                                      }
                                    }
                                  },
                                  [_vm._v("Copy Table")]
                                )
                              ]
                            )
                          : _c(
                              "th",
                              {
                                staticClass: "table-header",
                                attrs: { colspan: _vm.column_names.length }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.table_name) +
                                    " Table "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "copy-table",
                                    on: {
                                      click: function($event) {
                                        return _vm.copyTable()
                                      }
                                    }
                                  },
                                  [_vm._v("Copy Table")]
                                )
                              ]
                            )
                      ]),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm.button_name != null &&
                      _vm.perms.includes(_vm.button_perm) &&
                      _vm.collapsed == false
                        ? _c("th", { staticStyle: { width: "30px" } }, [
                            _vm._v(_vm._s(_vm.button_name))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.column_names, function(name, index) {
                        return _vm.column_names[index] != "Color" &&
                          _vm.collapsed == false
                          ? _c("th", [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    "white-space": "nowrap"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(name) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                  _vm.sort_value[index] == 0
                                    ? _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.sort(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "sort" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm.sort_value[index] == 1
                                    ? _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.sort(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "sort-up" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm.sort_value[index] == 2
                                    ? _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.sort(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "sort-down" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _vm.loading == true
              ? _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "table-header" }, [
                      _vm._v(_vm._s(_vm.table_name) + " Table Loading...")
                    ])
                  ])
                ])
              : _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "table-header" }, [
                      _vm._v(_vm._s(_vm.table_name) + " Table Empty")
                    ])
                  ])
                ]),
            _vm._v(" "),
            _vm.column_names.length > 0 && _vm.collapsed == false
              ? _c(
                  "tbody",
                  _vm._l(_vm.column_data, function(column, col) {
                    return _c(
                      "tr",
                      [
                        _vm.button_name != null &&
                        _vm.perms.includes(_vm.button_perm)
                          ? _c("td", { staticStyle: { width: "30px" } }, [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.select(col)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.button_name))]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(column, function(data, index) {
                          return _vm.column_names[index] != "Color"
                            ? _c("td", { attrs: { id: "tableRow-" + col } }, [
                                _vm.column_names[index] == "Document" &&
                                data != "null"
                                  ? _c(
                                      "div",
                                      [
                                        _c("document", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            id: index,
                                            dir: "doc_" + data + ".jpg",
                                            doc_id: data
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm.column_names[index] == "Side" &&
                                    data != "null"
                                  ? _c(
                                      "div",
                                      { attrs: { id: "side-" + col } },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(data) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm.column_names[index] == "CheckIn"
                                  ? _c("div", [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.check(
                                                true,
                                                _vm.column_data[col][0]
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Check In")]
                                      )
                                    ])
                                  : _vm.column_names[index] == "CheckOut"
                                  ? _c("div", [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.check(
                                                false,
                                                _vm.column_data[col][0]
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Check Out")]
                                      )
                                    ])
                                  : _vm.column_names[index] == "Add_Comment"
                                  ? _c("div", [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.add_comment(col)
                                            }
                                          }
                                        },
                                        [_vm._v("Add Comment")]
                                      )
                                    ])
                                  : _vm.column_names[index] == "Comments"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "14px",
                                          "overflow-y": "scroll",
                                          "max-height": "60px",
                                          "word-break": "break-word"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(data) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm.column_names[index] == "Date"
                                  ? _c(
                                      "div",
                                      { attrs: { id: "date-" + col } },
                                      [
                                        _c("datetime", {
                                          staticStyle: { width: "600px" },
                                          attrs: { index: col, use_X: false },
                                          on: { inputIndex: _vm.setDateTime },
                                          model: {
                                            value: _vm.date_values[col],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.date_values,
                                                col,
                                                $$v
                                              )
                                            },
                                            expression: "date_values[col]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm.column_names[index] == "Description"
                                  ? _c("div", [
                                      _c("textarea", {
                                        staticStyle: {
                                          width: "100%",
                                          "min-height": "50px"
                                        },
                                        attrs: { id: "desc-" + col },
                                        domProps: { value: data },
                                        on: { input: _vm.setDescriptionData }
                                      })
                                    ])
                                  : _vm.column_names[index] == "Type"
                                  ? _c(
                                      "div",
                                      [
                                        _c("autocomplete", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            id: "type-" + col,
                                            index: col,
                                            type: 51,
                                            value: data
                                          },
                                          on: { finish: _vm.setTypeData }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm.column_names[index] == "Images" &&
                                    data != "null"
                                  ? _c(
                                      "div",
                                      [
                                        _c("inventorypics", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            id: index,
                                            inventorypic_id: column[0],
                                            height:
                                              (75 * _vm.heightScale) / 100 +
                                              "px",
                                            count: data,
                                            imageCount: 5
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(data) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                              ])
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.navbar == true
        ? _c("div", { staticClass: "nav-bar" }, [
            _c(
              "div",
              _vm._l(_vm.nav_items, function(item, index) {
                return _vm.perms.includes(_vm.nav_item_perms[index])
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.button(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  : _vm._e()
              }),
              0
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfa65efc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfa65efc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout_8.vue
// module id = 764
// module chunks = 0